import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')
const RegisterApp = () => import('@/views/RegisterApp')
// Views

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Charts = () => import('@/views/charts/Charts')
const Widgets = () => import('@/views/widgets/Widgets')

// Views - Components
const Cards = () => import('@/views/base/Cards')
const Forms = () => import('@/views/base/Forms')
const Switches = () => import('@/views/base/Switches')
const Tables = () => import('@/views/base/Tables')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Icons
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')
const Brands = () => import('@/views/icons/Brands')
const Flags = () => import('@/views/icons/Flags')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')
const SignUp = () => import('@/views/SignUp')


const RegisterHomepage = () => import('@/views/RegisterHomepage')
const WhoAreYou = () => import('@/views/WhoAreYou')
const LoginNew = () => import('@/views/Login')
const CreateAccount = () => import('@/views/CreateAccount')
const ForgotPassword = () => import('@/views/ForgotPassword')
const VerifyCode = () => import('@/views/VerifyCode')
const ChooseLanguage = () => import('@/views/ChooseLanguage')
const HomeUser = () => import('@/views/HomeUser')
const ChooseLocation = () => import('@/views/ChooseLocation')
const ChooseDate = () => import('@/views/ChooseDate')
const FindServices = () => import('@/views/FindServices')
const HomeDiscover = () => import('@/views/HomeDiscover')
const TakePicture = () => import('@/views/TakePicture')
const CaptureDetail = () => import('@/views/CaptureDetail')
const Wishes = () => import('@/views/Wishes')
const Profile = () => import('@/views/HomeProfile')
const Request = () => import('@/views/Request')
const ServiceJob = () => import('@/views/ServiceJob')
const ProfileUser = () => import('@/views/ProfileUser')
const Tracking = () => import('@/views/Tracking')
const TrackingDetail = () => import('@/views/TrackingDetail')
const TrackingReview = () => import('@/views/TrackingReview')
const Booking = () => import('@/views/Booking')
const UploadImage = () => import('@/views/UploadImage')
const DoneUploadPicture = () => import('@/views/DoneUploadPicture')
const ChooseDateBooking = () => import('@/views/ChooseDateBooking')
const Notification = () => import('@/views/Notification')
const Setting = () => import('@/views/Setting')
const EditProfile = () => import('@/views/EditProfile')
const ChangePassword2 = () => import('@/views/ChangePassword2')
const Location = () => import('@/views/Location')
const EditAddress = () => import('@/views/EditAddress')
const EditCountry = () => import('@/views/EditCountry')
const EditCurrency = () => import('@/views/EditCurrency')
const EditLanguage = () => import('@/views/EditLanguage')
const EditSocmed = () => import('@/views/EditSocmed')
const EditWhatsapp = () => import('@/views/EditWhatsapp')
const EditTelegram = () => import('@/views/EditTelegram')
const ContactUs = () => import('@/views/ContactUs')
const NotificationSetting = () => import('@/views/NotificationSetting')
const AboutUs = () => import('@/views/AboutUs')
const HelpSupport = () => import('@/views/HelpSupport')
const TopupToken = () => import('@/views/TopupToken')
const HomeProfileGenie = () => import('@/views/HomeProfileGenie')
const ReferralProgram = () => import('@/views/ReferralProgram')
const InsertEmail = () => import('@/views/InsertEmail')

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
  
})



function configRoutes() {
  return [
    {
      path: '/',
       name: 'RegisterApp',
       component: RegisterApp
     },
     {
       path: '/RegisterApp',
       redirect: '/',
     children: [
      {
          path: 'theme',
          redirect: '/theme/colors',
          name: 'Theme',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'colors',
              name: 'Colors',
              component: Colors
            },
            {
              path: 'typography',
              name: 'Typography',
              component: Typography
            }
          ]
        },
        {
          path: 'charts',
          name: 'Charts',
          component: Charts
        },
        {
          path: 'widgets',
          name: 'Widgets',
          component: Widgets
        },
       
        {
          path: 'base',
          redirect: '/base/cards',
          name: 'Base',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'cards',
              name: 'Cards',
              component: Cards
            },
            {
              path: 'forms',
              name: 'Forms',
              component: Forms
            },
            {
              path: 'switches',
              name: 'Switches',
              component: Switches
            },
            {
              path: 'tables',
              name: 'Tables',
              component: Tables
            },
            {
              path: 'tabs',
              name: 'Tabs',
              component: Tabs
            },
            {
              path: 'breadcrumbs',
              name: 'Breadcrumbs',
              component: Breadcrumbs
            },
            {
              path: 'carousels',
              name: 'Carousels',
              component: Carousels
            },
            {
              path: 'collapses',
              name: 'Collapses',
              component: Collapses
            },
            {
              path: 'jumbotrons',
              name: 'Jumbotrons',
              component: Jumbotrons
            },
            {
              path: 'list-groups',
              name: 'List Groups',
              component: ListGroups
            },
            {
              path: 'navs',
              name: 'Navs',
              component: Navs
            },
            {
              path: 'navbars',
              name: 'Navbars',
              component: Navbars
            },
            {
              path: 'paginations',
              name: 'Paginations',
              component: Paginations
            },
            {
              path: 'popovers',
              name: 'Popovers',
              component: Popovers
            },
            {
              path: 'progress-bars',
              name: 'Progress Bars',
              component: ProgressBars
            },
            {
              path: 'tooltips',
              name: 'Tooltips',
              component: Tooltips
            }
          ]
        },
        {
          path: 'buttons',
          redirect: '/buttons/standard-buttons',
          name: 'Buttons',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'standard-buttons',
              name: 'Standard Buttons',
              component: StandardButtons
            },
            {
              path: 'button-groups',
              name: 'Button Groups',
              component: ButtonGroups
            },
            {
              path: 'dropdowns',
              name: 'Dropdowns',
              component: Dropdowns
            },
            {
              path: 'brand-buttons',
              name: 'Brand Buttons',
              component: BrandButtons
            }
          ]
        },
        {
          path: 'icons',
          redirect: '/icons/coreui-icons',
          name: 'CoreUI Icons',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'coreui-icons',
              name: 'Icons library',
              component: CoreUIIcons
            },
            {
              path: 'brands',
              name: 'Brands',
              component: Brands
            },
            {
              path: 'flags',
              name: 'Flags',
              component: Flags
            }
          ]
        },
        {
          path: 'notifications',
          redirect: '/notifications/alerts',
          name: 'Notifications',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'alerts',
              name: 'Alerts',
              component: Alerts
            },
            {
              path: 'badges',
              name: 'Badges',
              component: Badges
            },
            {
              path: 'modals',
              name: 'Modals',
              component: Modals
            }
          ]
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    },
  
    
    {
      path: '/',
      redirect: '/RegisterApp',
      name: 'RegisterApp',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [{
        path: 'RegisterApp',
        name: 'RegisterApp',
        component: RegisterApp
      }, ]
    },
   


    {
      path: '/',
      redirect: '/',
      name: 'RegisterHomepage',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [{
        path: 'RegisterHomepage',
        name: 'RegisterHomepage',
        component: RegisterHomepage
      }, ]
    },
   
    {
      path: '/',
      redirect: '/',
      name: 'Login',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [{
        path: 'Login',
        name: 'Login',
        component: LoginNew
      }, ]
    },

    {
      path: '/',
      redirect: '/',
      name: 'CreateAccount',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [{
        path: 'CreateAccount',
        name: 'CreateAccount',
        component: CreateAccount
      }, ]
    },

    {
      path: '/',
      redirect: '/',
      name: 'ForgotPassword',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [{
        path: 'ForgotPassword',
        name: 'ForgotPassword',
        component: ForgotPassword
      }, ]
    },

    {
      path: '/',
      redirect: '/',
      name: 'VerifyCode',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [{
        path: 'VerifyCode',
        name: 'VerifyCode',
        component: VerifyCode
      }, ]
    },

    {
      path: '/',
      redirect: '/',
      name: 'ChooseLanguage',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [{
        path: 'ChooseLanguage',
        name: 'ChooseLanguage',
        component: ChooseLanguage
      }, ]
    },
    {
      path: '/',
      redirect: '/WhoAreYou', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'WhoAreYou',
        component: WhoAreYou
      }]
    },
    {
      path: '/',
      redirect: '/HomeUser', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'HomeUser',
        component: HomeUser
      }]
    },
    {
      path: '/',
      redirect: '/ChooseLocation', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'ChooseLocation',
        component: ChooseLocation
      }]
    },
    {
      path: '/',
      redirect: '/ChooseDate', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'ChooseDate',
        component: ChooseDate
      }]
    },
    {
      path: '/',
      redirect: '/FindServices', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'FindServices',
        component: FindServices
      }]
    },
    {
      path: '/',
      redirect: '/HomeDiscover', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'HomeDiscover',
        component: HomeDiscover
      }]
    },
    {
      path: '/',
      redirect: '/TakePicture', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'TakePicture',
        component: TakePicture
      }]
    },
    {
      path: '/',
      redirect: '/CaptureDetail', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'CaptureDetail',
        component: CaptureDetail
      }]
    },
    {
      path: '/',
      redirect: '/Wishes', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'Wishes',
        component: Wishes
      }]
    },
    {
      path: '/',
      redirect: '/HomeProfile', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'HomeProfile',
        component: Profile
      }]
    },
    {
      path: '/',
      redirect: '/Request', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'Request',
        component: Request
      }]
    },
    {
      path: '/',
      redirect: '/ServiceJob', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'ServiceJob',
        component: ServiceJob
      }]
    },
    {
      path: '/',
      redirect: '/ProfileUser', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'ProfileUser',
        component: ProfileUser
      }]
    },
    {
      path: '/',
      redirect: '/Tracking', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'Tracking',
        component: Tracking
      }]
    },
    {
      path: '/',
      redirect: '/TrackingDetail', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'TrackingDetail',
        component: TrackingDetail
      }]
    },
    {
      path: '/',
      redirect: '/TrackingReview', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'TrackingReview',
        component: TrackingReview
      }]
    },
    {
      path: '/',
      redirect: '/Booking', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'Booking',
        component: Booking
      }]
    },
    {
      path: '/',
      redirect: '/UploadImage', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'UploadImage',
        component: UploadImage
      }]
    },
    {
      path: '/',
      redirect: '/DoneUploadPicture', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'DoneUploadPicture',
        component: DoneUploadPicture
      }]
    },
    {
      path: '/',
      redirect: '/ChooseDateBooking', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'ChooseDateBooking',
        component: ChooseDateBooking
      }]
    },
    {
      path: '/',
      redirect: '/Notification', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'Notification',
        component: Notification
      }]
    },
    {
      path: '/',
      redirect: '/Setting', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'Setting',
        component: Setting
      }]
    },
    {
      path: '/',
      redirect: '/EditProfile', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'EditProfile',
        component: EditProfile
      }]
    },
    {
      path: '/',
      redirect: '/ChangePassword2', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'ChangePassword2',
        component: ChangePassword2
      }]
    },
    {
      path: '/',
      redirect: '/Location', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'Location',
        component: Location
      }]
    },
    {
      path: '/',
      redirect: '/EditAddress', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'EditAddress',
        component: EditAddress
      }]
    },
    {
      path: '/',
      redirect: '/EditCountry', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'EditCountry',
        component: EditCountry
      }]
    },
    {
      path: '/',
      redirect: '/EditCurrency', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'EditCurrency',
        component: EditCurrency
      }]
    },
    {
      path: '/',
      redirect: '/EditLanguage', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'EditLanguage',
        component: EditLanguage
      }]
    },
    {
      path: '/',
      redirect: '/EditSocmed', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'EditSocmed',
        component: EditSocmed
      }]
    },
    {
      path: '/',
      redirect: '/EditWhatsapp', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'EditWhatsapp',
        component: EditWhatsapp
      }]
    },
    {
      path: '/',
      redirect: '/EditTelegram', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'EditTelegram',
        component: EditTelegram
      }]
    },
    {
      path: '/',
      redirect: '/ContactUs', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'ContactUs',
        component: ContactUs
      }]
    },
    {
      path: '/',
      redirect: '/NotificationSetting', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'NotificationSetting',
        component: NotificationSetting
      }]
    },
    {
      path: '/',
      redirect: '/AboutUs', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'AboutUs',
        component: AboutUs
      }]
    },
    {
      path: '/',
      redirect: '/HelpSupport', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'HelpSupport',
        component: HelpSupport
      }]
    },
    {
      path: '/',
      redirect: '/TopupToken', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'TopupToken',
        component: TopupToken
      }]
    },
    {
      path: '/',
      redirect: '/HomeProfileGenie', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'HomeProfileGenie',
        component: HomeProfileGenie
      }]
    },
    {
      path: '/',
      redirect: '/ReferralProgram', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'ReferralProgram',
        component: ReferralProgram
      }]
    },
    {
      path: '/',
      redirect: '/SignUp', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'SignUp',
        component: SignUp
      }]
    },
    {
      path: '/',
      redirect: '/InsertEmail', // Redirect to the path of the WhoAreYou component
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'InsertEmail',
        component: InsertEmail
      }]
    }

    
   
    
  ]
}
